import React from 'react';
import { Fade } from "react-awesome-reveal";
import './Cards.css';





function Cards() {
  return (
    <div className='cards'>
      <div className='journey'>
      <img className='journey-image' src='/images/planting.png' alt="planting"/>
      <div>
      <Fade className='journey-text' fraction={.75} duration={3000}>
      <p> 
        From our previous years harvest, we take the seeds from the most spicy and robust peppers.
        From there, we use our in house soil blend to assure we will have the healthiest and productive growth.
        We then carefully hand plant each pepper, noting the depth and compaction to set our harvest up for success.
      </p>
      </Fade>
      </div>
    </div>
    <div className='journey'>
      <img className='journey-image' src='/images/harvesting.png' alt="harvesting" width={590} height={"auto"}/>
      <div>
      <Fade className='journey-text' fraction={.75} duration={3000}>
      <p> 
       Towards the end of the season, we are left with beautifully ripe peppers. We use the trusted and tried method of sampling from each plant to see the 
       spiciness and overall flavor depth. We note the most performant plants and peppers to extract the seeds and store for next years planting and begin the 
       processing.
      </p>
      </Fade>
      </div>
    </div>
    <div className='journey'>
      <img className='journey-image' src='/images/processing2.jpg' alt="processing" width={590} height={320}/>
      <div>
      <Fade className='journey-text' fraction={.75} duration={3000}>
      <p> 
        At Papis Peppers, we produce seeds, spices and salsas. For our salsas we gather some of the freshest ingredients in the area and bring it together with our peppers.
        Our salsas do not contain any chemicals or dyes. We rely on the color of the peppers and the naturally preserving qualities of ph levels and canning to ensure a fresh, tasty
        and safe product.
      </p>
      </Fade>
      </div>
    </div>
    </div>
  );
}

export default Cards;
